<template>
  <footer class="footer-container">
    广东微牛电子商务有限公司版权所有
  </footer>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>
  .footer-container {
    width: 100%;
    padding: 28px 16px;
    text-align: center;
    font-size: 12px;
    letter-spacing: 0.05em;
    color: rgba(255, 255, 255, 0.32);
  }
</style>
